import { Stack } from '@mui/material';
import { FC } from 'react';
import { NavItem, MenuItem } from './item';

type Props = {
  config: Array<MenuItem>;
};

export const MediumScreenMenu: FC<Props> = ({ config }) => {
  return (
    <Stack direction="row" sx={{ display: { xs: 'none', md: 'flex' } }}>
      {config.map((item) => (
        <NavItem key={item.route} {...item} />
      ))}
    </Stack>
  );
};
